import mostBiToolsMd from "./most-bi-tools-ask-you-to-trust-the-data.md?raw";
import nobodyCaresAboutYourSlidesMd from "./nobody-cares-about-your-slides.md?raw";
import tailoredNotCustomizableMd from "./tailored-not-customizable.md?raw";
import useAiToAutomateMd from "./use-ai-to-automate-the-tasks-that-suck.md?raw";
import buildItYourselfMd from "./you-could-build-your-next-ai-workflow-yourself.md?raw";

export interface BlogPostShareImage {
  path: string;
  width: number;
  height: number;
  alt: string;
}

export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  date: string;
  displayDate: string;
  excerpt: string;
  shareImage: BlogPostShareImage | null;
  body: string;
}

// Posts render in array order on /blog (keep newest / lead post first). To add a post: drop a
// markdown file in this folder (headings start at ##; the page supplies the H1), import it with
// ?raw, add an entry here, and add the URL to public/sitemap.xml.
export const blogPosts: BlogPost[] = [
  {
    slug: "nobody-cares-about-your-slides",
    title: "Nobody Cares About Your Slides",
    description:
      "Why we swapped customer slide decks for a plain weekly doc — what shipped, what slipped, what's blocked — built with Claude in an afternoon and shared live over Slack.",
    date: "2026-08-17",
    displayDate: "Aug 17, 2026",
    excerpt:
      "I showed up to a roadmap meeting with a little homemade HTML doc and, instead of dressing anything up, just said plainly: here's what's done, here's what isn't. By the end of the call she asked for a copy — not of a fancy deck, but of the brutally honest, kinda ugly one.",
    shareImage: null,
    body: nobodyCaresAboutYourSlidesMd,
  },
  {
    slug: "tailored-not-customizable",
    title: "Tailored, Not Customizable",
    description:
      "Customizable means you bend your business to fit the tool. Tailored means the tool learns your business — your MRR definition, your commission rules, your variance lines — encoded, not configured.",
    date: "2026-08-12",
    displayDate: "Aug 12, 2026",
    excerpt:
      "\"Customizable\" means you bend your business to fit the tool. \"Tailored\" means the tool learns your business. That's not a word game. It's the whole difference.",
    shareImage: {
      path: "/images/blog/tailored-not-customizable.png",
      width: 2000,
      height: 1250,
      alt: "Customizable versus tailored — the same business shape: one hangs off a one-size template, gaps and all; the other is cut to your exact measurements",
    },
    body: tailoredNotCustomizableMd,
  },
  {
    slug: "you-could-build-your-next-ai-workflow-yourself",
    title: "You Could Probably Build Your Next AI Workflow Yourself. Here's Why You Shouldn't.",
    description:
      "The build is the easy part — owning the fragile machine forever is the part nobody quotes you on. Why AI workflows need a governed, auditable data foundation, not another weekend prototype.",
    date: "2026-07-10",
    displayDate: "Jul 10, 2026",
    excerpt:
      "Every leader has had the thought: I could build this report myself. And you're not wrong — you probably could. The problem isn't whether you can build it. It's what you own the day after you do.",
    shareImage: {
      path: "/images/blog/build-it-yourself-vs-datafabriq.png",
      width: 2760,
      height: 1800,
      alt: "Build it yourself — taped-together, breaks silently — versus DataFabrIQ: unified, auditable, one source of truth",
    },
    body: buildItYourselfMd,
  },
  {
    slug: "most-bi-tools-ask-you-to-trust-the-data",
    title: "Most BI tools ask you to trust the data. We think you shouldn't have to.",
    description:
      "Introducing DataFabrIQ: one auditable data model across CRM, billing, accounting, and payments — and purpose-built workflows that defend every number underneath your dashboards.",
    date: "2026-07-06",
    displayDate: "Jul 6, 2026",
    excerpt:
      "The most important workflows — MRR close, pipeline review, commission runs — are run in a tangle of spreadsheets, scripts, and Slack threads. The answer isn't another dashboard. So we built the underneath.",
    shareImage: {
      path: "/images/blog/the-dashboard-is-the-last-mile.jpg",
      width: 1600,
      height: 900,
      alt: "The dashboard is the last mile. We defend the first: the data underneath it.",
    },
    body: mostBiToolsMd,
  },
  {
    slug: "use-ai-to-automate-the-tasks-that-suck",
    title: "Use AI to Automate the Tasks That Suck (And Empower the Humans Who Aren't Going Anywhere)",
    description:
      "AI won't replace your finance team. It should take the reconciliations, commission runs, and rebuilt spreadsheets off their plate — and here's why most AI never makes it past the demo.",
    date: "2026-07-06",
    displayDate: "Jul 6, 2026",
    excerpt:
      "The zeitgeist argues \"AI will replace your whole team\" versus \"it's all hype\". Both takes are loud, both are wrong. The real conversation: handing AI the tasks you don't want your team spinning cycles on in the first place.",
    shareImage: null,
    body: useAiToAutomateMd,
  },
];
